import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LMDrawerComponent } from './lm-drawer/lm-drawer.component';
import { LMDrawerSideComponent } from './lm-drawer-side/lm-drawer-side.component';
import { LMDrawerContentComponent } from './lm-drawer-content/lm-drawer-content.component';
import { LMDrawerSideCollapsedComponent } from './lm-drawer-side-collapsed/lm-drawer-side-collapsed.component';
import { BreakpointChangeService } from './breakpoint-change.service';

@NgModule({
  declarations: [
    LMDrawerComponent,
    LMDrawerSideComponent,
    LMDrawerContentComponent,
    LMDrawerSideCollapsedComponent,
  ],
  providers: [ BreakpointChangeService ],
  imports: [ CommonModule ],
  exports: [
    LMDrawerComponent,
    LMDrawerSideComponent,
    LMDrawerContentComponent,
    LMDrawerSideCollapsedComponent,
  ]
})
export class DrawerModule {}
